<template>
  <div class="dhzplanList">
    <p class="title">待汇总方案</p>
    <!-- 表 -->
    <div class="content">
      <div class="box" v-for="item in tableData" :key="item.id">
        <p class="b_t">患者姓名：{{item[0].patientName}} </p>
        <p class="b_t">所属小组：{{item[0].groupName}} </p>
        <el-button type='primary' @click='hz(item)'>汇总</el-button>
        <el-table class="table-simple" :data="item" style="width: 100%" header-row-class-name="headclass">
          <el-table-column prop="title" label="方案标题" align="center">
          </el-table-column>
          <el-table-column prop="conclusion" label="总结" align="center">
          </el-table-column>
          <el-table-column prop="plan" label="方案" align="center">
          </el-table-column>
          <el-table-column prop="dorName" label="提交医生" align="center">
          </el-table-column>
          <el-table-column prop="departmentName" lgetSecretUsersabel="医生科室" align="center">
          </el-table-column>
          <el-table-column prop="updateTime" label="提交时间" align="center">
          </el-table-column>
          <el-table-column prop="handle" label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <!-- 编辑 -->
              <a class="txt-btn btn-yellow" v-if='scope.row.ownStatus==1' @click="handelEdit(scope.row,1)">编辑</a>
              <a class="txt-btn btn-yellow" v-if='scope.row.ownStatus==0' style="color:#ccc">编辑</a>
              <a class="txt-btn btn-yellow" @click="handelEdit(scope.row,2)">详情</a>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>


    <!-- 方案 -->
    <el-dialog title="汇总方案" :visible.sync="fanganvisable" @close="closefaDialog" :modal-append-to-body="false">
      <!-- <p>于2019-11-19 13:00:00提交</p> -->
      <p class="title" style="font-size:20px;">各科室方案</p>
      <el-tabs type="border-card" class="noshad">
        <el-tab-pane v-for='item in planList' :label="item.dorName" :key="item.id">
          <div class="doctab">
            <el-form ref="form" :model="form" label-width="80px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="科室:">
                    {{item.departmentName}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="标题:">
                    {{item.title}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="总结:">
                    {{item.conclusion}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="方案:">
                    {{item.plan}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>

      </el-tabs>
      <el-form ref="form" :model="form" label-width="80px">

        <p class="title" style="font-size:20px;">汇总结果</p>

        <el-row>
          <el-col :span="24">
            <el-form-item label="方案标题:">
              <el-input v-model="form.title" placeholder='请输入方案标题'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="总结:">
              <el-input v-model="form.conclusion" placeholder='请输入总结'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体方案:">
              <el-input v-model="form.plan" type="textarea" placeholder='请输入具体方案'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-btn" type="primary" @click="savePlan(1)">确 定
        </el-button>
        <el-button @click="closefaDialog">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 方案1 -->
    <el-dialog title="编辑方案" :visible.sync="editfanganvisable" class="fangandia" @close="closeedfaDialog"
      :modal-append-to-body="false">
      <!-- <p>于2019-11-19 13:00:00提交</p> -->
      <el-form ref="form" :model="form1" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="患者姓名:">
              {{form1.patientName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属小组:">
              {{form1.groupName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="方案标题:">
              <el-input v-model="form1.title" placeholder='请输入方案标题' :disabled="isxq">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="总结:">
              <el-input v-model="form1.conclusion" placeholder='请输入总结' :disabled="isxq">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体方案:">
              <el-input v-model="form1.plan" type="textarea" placeholder='请输入具体方案' :disabled="isxq">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交时间:">
              {{form1.updateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if='isxq==false'>
        <el-button class="add-btn" type="primary" @click="editPlan(2)">确 定
        </el-button>
        <el-button @click="closeedfaDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  // 接口引用
  import {
    getAllUnSummaryPlans,
    editPlan,
    savePlan
  } from "@/api/getData";
  import {} from "@/config/validform";
  export default {
    // 变量定义
    data() {
      return {
        tableData: [],
        currentPage: 1,
        total: 0,
        fanganvisable: false,
        form: {},
        form1: {},
        editfanganvisable: false,
        isxq: false,
        planList: [],
      }
    },

    created() {
      this.getAllUnSummaryPlans()
    },
    methods: {
      hz(item) {
        console.log(item)
        this.planList = item
        this.fanganvisable = true;

      },
      // 新增方案
      async savePlan(type) {
        let subform = {};
        if (this.form.title == '') {
          this.$message({
            type: "error",
            message: '请输入方案标题'
          });
        } else if (this.form.conclusion == '') {
          this.$message({
            type: "error",
            message: '请输入总结'
          });
        } else if (this.form.plan == '') {
          this.$message({
            type: "error",
            message: '请输入方案'
          });
        } else {

          subform.userId = this.planList[0].userId;
          subform.patientName = this.planList[0].patientName;
          subform.imGroupId = this.planList[0].imGroupId;
          subform.conclusion = this.form.conclusion;
          subform.plan = this.form.plan;
          subform.title = this.form.title;
          subform.submitType = type
          var res = await savePlan(subform);
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: '汇总成功',
              duration: 1500,
            });
            this.closefaDialog();
            this.getAllUnSummaryPlans()
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        }
      },
      // 编辑方案
      async editPlan(type) {
        let subform = {};
        if (this.form1.title == '') {
          this.$message({
            type: "error",
            message: '请输入方案标题'
          });
        } else if (this.form1.conclusion == '') {
          this.$message({
            type: "error",
            message: '请输入总结'
          });
        } else if (this.form1.plan == '') {
          this.$message({
            type: "error",
            message: '请输入方案'
          });
        } else {
          subform.id = this.form1.id;
          subform.conclusion = this.form1.conclusion;
          subform.plan = this.form1.plan;
          subform.title = this.form1.title;
          subform.submitType = type
          var res = await editPlan(subform);
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: '编辑成功'
            });
            this.closeedfaDialog();
            this.getAllUnSummaryPlans()
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        }
      },
      // 获取待汇总方案列表
      async getAllUnSummaryPlans() {
        var res = await getAllUnSummaryPlans();
        if (res.code == "0") {
          this.tableData = res.data
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      closefaDialog() {
        this.form = {};
        this.fanganvisable = false
      },
      closeedfaDialog() {
        this.form1 = {};
        this.editfanganvisable = false
      },

      //修改当前页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getgoodslist();
      },
      handelEdit(row, type) {
        if (type == 1) {
          this.isxq = false
        } else {
          this.isxq = true
        }
        let txt = JSON.stringify(row);
        this.form1 = JSON.parse(txt);
        this.editfanganvisable = true;

      },
    }
  }

</script>
<style lang="less">
  .el-main {
    background-color: #f0f2f5;
  }

  .dhzplanList {
    width: 98%;
    float: left;
    margin: 1%;
    height: 96%;
    padding: 1%;
    background-color: #fff;

    .box {
      width: 100%;
      float: left;
      margin-bottom: 20px;

      .el-button {
        float: left;
      }

      .b_t {
        width: auto;
        float: left;
        line-height: 40px;
        margin-right: 20px;
      }
    }

    .title {
      font-size: 25px;
      font-weight: 600;
      text-align: left
    }

    .content {
      width: 100%;

    }

    .headclass {

      tr,
      th {
        background-color: rgba(247, 247, 247, 1);
      }

    }

    .toolbar {
      width: 100%;
      float: left;
      margin-bottom: 30px;
    }

    .toolbar .el-row label {
      float: left;
      width: 20%;
      line-height: 40px;
      ;
    }

    .toolbar .el-row .el-input {
      float: left;
      width: 80%;
      height: 40px;
    }

    .toolbar .el-row .el-select {
      float: left;
      width: 80%;
      height: 40px;

      .el-input {
        width: 100%
      }
    }

    .page {
      text-align: right;
      padding: 20px 0
    }

    .fangandia {
      .el-dialog {
        width: 500px !important;

        // height: 400px;
        .el-dialog__body {
          padding-bottom: 0
        }
      }

      .el-form {
        width: 100%;
        margin-left: 0;
      }
    }

    .el-form-item__content {
      text-align: left;
    }

    .doctab {

      .el-form-item {
        margin-bottom: 0;
      }
    }

    .noshad {
      -webkit-box-shadow: none;
      box-shadow: none;
      margin-bottom: 20px;
    }

    .el-dialog__body {
      padding: 020px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/dhzplanList.vue